export default "__VITE_ASSET__BjP8QVx8__"